export const getPromocodeFromUrl = (url: string): string | null => {
  const promocodeRegex = /[?&]promocode=([^&]+)/
  const promocode = url.match(promocodeRegex)
  return promocode ? promocode[1] : null
}
